
Formatter.$inject = ['$interpolate'];
export function Formatter($interpolate: ng.IInterpolateService) {
    return (item, name) => {
        if (name) {
            if (_.startsWith(item, "9999-09-09")) {
                return "Perpetuity";
            }
            var result = $interpolate('{{value | ' + name + '}}');
            return result({ value: item });
        } else {
            return item;
        }
    }
}

